<template>
  <div class="content">
    <div class="list" v-if="devList.length && requestEnd" v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="10">
      <div v-for="dev in devList" :key="dev.id" class="item" @click="toDetail(dev)">
        <div class="affiliation-info">
          <img :src="public_path + '/static/images/Fill.svg'" alt="">
          <div class="aff">
            <span class="aff-name">所属教练：{{dev.coach_name}}</span>
            <span class="aff-id">设备编号：{{dev.soft_sn}}</span>
          </div>
        </div>
        <div class="status">
          <span>{{dev.state_cn}}</span>
          <img :src="public_path + '/static/images/arrow_right.svg'" alt="">
        </div>
      </div>
    </div>
    <div class="no-equipment" v-if="!devList.length && requestEnd">
      <img :src="public_path + '/static/images/no_equipment.png'" alt="">
      <p>暂无设备</p>
    </div>
  </div>
</template>
<script>
import { getDev } from '@/http/api'
import Vue from 'vue';
import infiniteScroll from 'vue-infinite-scroll';
Vue.use(infiniteScroll)
export default {
  data () {
    return {
      devList: [],
      public_path: process.env.PUBLICK_PATH,
      requestEnd: false,
      page: 1,
      total_page: 0
    }
  },
  methods: {
    loadMore () {
      this.page += 1
      if (this.page > this.total_page) {
        return
      } else {
        this.getDev()
      }
    },
    toDetail (dev) {
      this.$router.push({
        name: 'Equipmentdetail',
        params: {dev: dev}
      })
    },
    getDev () {
      getDev({
        page: this.page,
        limit: 20,
        token: localStorage.token
      }).then(res => {
        console.log(res)
        if (res.code === 0) {
          this.devList = res.data.data ? this.devList.concat(res.data.data) : this.devList
          this.requestEnd = true
          this.total_page = Math.ceil(res.data.total_num / 20)
        }
      })
    }
  },
  mounted () {
    this.getDev()
  }
}
</script>
<style lang="scss" scoped>
.content {
  font-size: 0;
  color: #333;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: #f5f5f5;
  overflow-y: auto;
  -webkit-overflow-scrolling:touch;
  .list {
    padding: 0 .3rem;
    .item {
      width: 6.90rem;
      height: 2rem;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 2px 30px 0px rgba(222, 225, 225, 0.5);
      border-radius: .16rem;
      margin-top: .3rem;
      display: -webkit-flex;
      align-items: center;
      .affiliation-info {
        flex: 2;
        img {
          display: inline-block;
          vertical-align: top;
          width: .50rem;
          height: .38rem;
          margin-left: .3rem;
        }
        .aff {
          display: inline-block;
          vertical-align: top;
          margin-left: .4rem;
          text-align: left;
          .aff-name {
            font-size: .3rem;
            font-weight: 600;
            line-height: 1;
          }
          .aff-id {
            display: block;
            margin-top: .4rem;
            font-size: .24rem;
            color: rgba(51, 51, 51, .5);
          }
        }
      }
      .status {
        flex: 1;
        text-align: right;
        padding-right: .3rem;
        box-sizing: border-box;
        span {
          font-size: .26rem;
          color: #02B389;
          display: inline-block;
          vertical-align: middle;
          line-height: 1.6;
        }
        img {
          width: .14rem;
          height: .25rem;
          display: inline-block;
          vertical-align: middle;
          margin-left: .14rem;
        }
      }
    }
  }
}
.no-equipment {
  img {
    width: 2.45rem;
    height: 1.64rem;
    display: block;
    margin-left: auto;
    margin-right: auto;
    margin-top: 2.62rem;
  }
  p {
    font-size: .28rem;
    color: rgba(51, 51, 51, 0.5);
    line-height: .40rem;
    margin-top: .8rem;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/equipment/Equipment.vue